import mixpanel from 'mixpanel-browser'
// import { google_ga } from '../config'

// Node environment check
// let env_check = process.env.NODE_ENV === 'development' ? 'dev' : 'prod'

// Mixpanel action setters
export const mixpanelActions = {
  alias: (id) => mixpanel.alias(id),
  people: {
    set: (props) => mixpanel.people.set(props)
  }
}

// Event Tracker
export const trackEvent = ({ eventName, props = {}, withUTMParams = true }) => {
  const updatedProps = withUTMParams
    ? { ...props, ...JSON.parse(sessionStorage.getItem('UTM')) }
    : props

  if (window.Moengage) {
    window.Moengage.track_event(eventName, updatedProps)
  }
  mixpanel.track(eventName, updatedProps)
}

export const identifyUser = (id) => {
  if (window.Moengage) {
    window.Moengage.add_unique_user_id(id)
  }
  mixpanel.identify(id)
}

// Close session
export const closeSession = () => {
  if (window.Moengage) {
    window.Moengage.destroy_session()
  }
  mixpanel.reset()
}

// Meta pixel pageview - Google analitycs pageview
export const pageview = (url) => {
  if (typeof window !== 'undefined') {
    window.fbq('track', 'PageView')
    window.gtag('config', process.env.GOOGLE_ANALYTICS, {
      page_path: url
    })
  }
}
